<template>
  <div
    class="border-t-2 border-blue-400 pt-6 md:pt-0 md:border-t-0 md:flex mb-8 relative"
    style="min-height: 15rem;"
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true,
    }"
  >
    <img
      v-if="isVisible"
      :src="episode.art.full.source_url"
      class="mb-8 md:mb-0 md:w-64 h-auto w-full"
    />
    <div class="flex-1 md:pt-3 md:w-0">
      <h2 class="h3 md:ml-6">
        <a
          :href="episode.link"
          class="hover:text-green-400"
          target="_blank"
          v-text="`Episode ${ episode.episode }`"
        ></a>
      </h2>
      <div
        v-if="isVisible && episode.stories.length"
        class="md:-ml-8 flex overflow-auto rounded-lg"
      >
        <StoryPreview
          class="flex-shrink-0 mr-2"
          style="width: 20rem"
          v-for="(story, k) in episode.stories"
          :key="k"
          :id="story"
        />
      </div>
      <p v-else class="md:ml-6">
        No stories found.
        <router-link
          v-if="isAdmin"
          :to="{
            name: 'story-new',
            query: {
              season: 13,
              episode: episode.episode,
              id
            }
          }"
          v-text="'Add Story.'"
        ></router-link>
      </p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';
import StoryPreview from '@/components/StoryPreview.vue';

export default {
  name: 'EpisodeCollection',
  props: {
    id: {
      type: String
    },
    episode: {
      type: Object
    }
  },
  components: {
    StoryPreview,
  },
  data() {
    return {
      isVisible: false
    };
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'users/loggedInUser'
    }),
    isAdmin() {
      return this.loggedInUser && this.loggedInUser.role === 'admin';
    }
  },
  methods: {
    visibilityChanged(isVisible) {
      this.isVisible = isVisible;
    }
  }
};
</script>

<style lang="scss">
</style>
